import { ApiParameter, get, post, request } from "@insite/client-framework/Services/ApiService";
import uniqueId from "@insite/mobius/utilities/uniqueId";

const itemTrackingCollectionUrl = "/api/v2/Verizon/GetItemTrackings";
export const itemTrackingExportUrl = "/api/v2/Verizon/ItemTrackingExport";
const itemTrackingImportUrl = "/api/v2/ItemTracking/Import";

export interface ItemTrackingCollectionParam extends ApiParameter {
    customerPartNumber?: string;
    itemId?: string;
    supplierName?: string;
    fromDate?: string;
    toDate?: string;
    page?: number | null;
    pageSize?: number;
    businessCaseId?: string;
    isExport?: boolean;
    id?: string;
    sort?: string;
}

export interface ItemTrackingCollectionResult {
    itemTrackings: ItemTracking[];
    pagination: Pagination;
}

export interface ItemTracking {
    id: string;
    customerPartNumber: string;
    itemId: string;
    customerSupplierPartNumber: string;
    customerSupplierItemDesc: string;
    supplierId: string;
    supplierName: string;
    inventoryType: string;
    previousSellPrice: string;
    lastEffectiveDatePrevSellPrice: string;
    customerBaselineCost: string;
    customerBaseUOM: string;
    sourceCost: string;
    customerUnitPrice: string;
    customerPerPrice: string;
    sellUOM: string;
    markUp: string;
    customerOrderMultipleText: string;
    customerMinOrderQtyText: string;
    supplierOrderMultipleText: string;
    supplierMinOrderQtyText: string;
    supplierPartNumber: string;
    supplierItemDesc: string;
    customMadeForCustomer: boolean;
    contractNumber: string;
    contractExpiryDate: string;
    customerCriticalIndicator: string;
    customerSSIIndicator: string;
    customerProductManager: string;
    changedFromCustomerItemNumber: string;
    replacementCustomerItemNumber: string;
    leadTimeText: string;
    changeType: string;
    changeNote: string;
    changeEntryDate: string;
    changeEffectiveDate: string;
    changeSentToCustomerDate: string;
    businessCaseId: number;
    customProperties: CustomProperty[];
    createdOn: string;
    createdBy: string;
    modifiedOn: string;
    modifiedBy: string;
}

export interface CustomProperty {
    id: string;
    parentTable: string;
    parentId: string;
    name: string;
    value: string;
    customProperties: CustomProperty2[];
    createdOn: string;
    createdBy: string;
    modifiedOn: string;
    modifiedBy: string;
}

export interface CustomProperty2 {}

export interface Pagination {
    currentPage: number;
    page: number;
    pageSize: number;
    defaultPageSize: number;
    totalItemCount: number;
    numberOfPages: number;
    pageSizeOptions: number[];
    sortOptions: SortOptions;
    sortType: SortType;
    nextPageUri: string;
    prevPageUri: string;
}

export interface SortOptions {}

export interface SortType {}

export type ItemTrackings = ItemTracking[];

export const getItemTrackingCollection = async (parameters: ItemTrackingCollectionParam) => {
    const response = await get<ItemTrackingCollectionResult>(itemTrackingCollectionUrl, {
        ...parameters,
        id: uniqueId(),
    } as ItemTrackingCollectionParam);

    return response;
};

// export const exportItemTrackingToExcel = async (parameters: ItemTrackingCollectionParam) => {
//     const response = await post(itemTrackingExportUrl, {
//         ...parameters,
//         id: uniqueId(),
//     } as ItemTrackingCollectionParam);

//     return response;
// };

export const uploadItemTrackingApi = async (parameters: any) => {
       try {
        
        const formData = new FormData();
        formData.append("File", parameters.file);
        const response = await request<any>(itemTrackingImportUrl, "POST", {}, formData);
        return response;
    
    } catch (error) {
       throw error;
    }
   
};
